module.exports = __webpack_public_path__ + "static/img/kf1-arrow.628d2f4b.svg";